



import { axiosPrivate } from "api/axios";
import { AUTH_TOKEN } from "constants/AuthConstant";
import Cookies from "js-cookie";

const NannyService = {};

const getAuthHeader = () => ({
  Authorization: `Bearer ${Cookies.get(AUTH_TOKEN)}`,
});

NannyService.addNanny = function (data) {
  return axiosPrivate({
    method: "post",
    url: "/BabySitters",
    data: data,
    headers: getAuthHeader(),
  });
};

NannyService.addNannyCv = function (data, id) {
  return axiosPrivate({
    method: "post",
    url: `/BabySitters/uploadCv/${id}`,
    data: data,
    headers: getAuthHeader(),
  });
};

NannyService.addNannyPhoto = function (data, id) {
  return axiosPrivate({
    method: "post",
    url: `/BabySitters/uploadAvatar/${id}`,
    data: data,
    headers: getAuthHeader(),
  });
};

NannyService.UpdateNanny = function (id, data) {
  return axiosPrivate({
    method: "put",
    url: `/BabySitters/${id}`,
    data: data,
    headers: getAuthHeader(),
  });
};

NannyService.getNannies = function () {
  return axiosPrivate({
    method: "get",
    url: `/BabySitters/allNannies`,
    headers: getAuthHeader(),
  });
};

NannyService.getOneNanny = function (id) {
  return axiosPrivate({
    method: "get",
    url: `/BabySitters/${id}`,
    headers: getAuthHeader(),
  });
};

NannyService.deleteNanny = function (id) {
  return axiosPrivate({
    params: { id: id },
    method: "delete",
    url: `/BabySitters`,
    headers: getAuthHeader(),
  });
};

NannyService.getApplications = function (id) {
  return axiosPrivate({
    method: "get",
    url: `/BabySitters/jobApplications/${id}`,
    headers: getAuthHeader(),
  });
};

NannyService.getEvaluations = function (id) {
  return axiosPrivate({
    method: "get",
    url: `/BabySitters/ratings/${id}`,
    headers: getAuthHeader(),
  });
};

NannyService.toggleStatus = function (id, data) {
  return axiosPrivate({
    method: "put",
    url: `/BabySitters/toggleBabySitterStatus/${id}`,
    data: data,
    headers: getAuthHeader(),
  });
};

NannyService.toggleApplicationStatus = function (id, data) {
  return axiosPrivate({
    method: "put",
    url: `/BabySitters/toggleBabySitterStatus/${id}`,
    data: data,
    headers: getAuthHeader(),
  });
};

NannyService.deleteApplication = function (id) {
  return axiosPrivate({
    params: { id: id },
    method: "delete",
    url: `/Applications`,
    headers: getAuthHeader(),
  });
};

export default NannyService;

